import { Box,  Typography } from '@material-ui/core'
import React from 'react'


const Profile = () => {
    return (
        <Box py={10}>
            <Typography
            variant="h1"
          >
            PROFİLE
          </Typography>



        </Box>
            
    )
}

export default Profile
